var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratulation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.471,
    height: 85.576,
    viewBox: "0 0 85.471 85.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fbd100}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M42.818 0a42.788 42.788 0 1 0 42.736 42.788A42.887 42.887 0 0 0 42.818 0zm0 80.227a37.44 37.44 0 1 1 37.393-37.44 37.527 37.527 0 0 1-37.393 37.44z",
    className: "cls-1",
    "data-name": "Path 1",
    transform: "translate(-.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M72.031 47.059l-22.169 22.2-11.218-11.235a2.646 2.646 0 0 0-3.744 3.743l13.088 13.1a2.579 2.579 0 0 0 3.739 0L75.77 50.8a2.646 2.646 0 0 0-3.739-3.744z",
    className: "cls-1",
    "data-name": "Path 2",
    transform: "translate(-12.468 -16.84)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulation);
export default __webpack_public_path__ + "static/media/congratulation.f5058d01.svg";
export { ForwardRef as ReactComponent };